var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 2,
    viewBox: "0 0 134 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 2,
    fill: "#ECF0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperConnector);
export default __webpack_public_path__ + "static/media/StepperConnector.70d903d6e1c02fa5f9b3d6f663fa6f44.svg";
export { ForwardRef as ReactComponent };